import { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { Link } from "react-router-dom";
import { db } from "../../firebase/firebaseConfig";

export default function MoreLikeThis({ currentProduct }) {
  const [relatedProducts, setRelatedProducts] = useState([]);

  useEffect(() => {
    const fetchRelatedProducts = async () => {
      if (!currentProduct) return;

      const snapshot = await getDocs(collection(db, "inventory"));

      const currentCategories = currentProduct.category || [];
      const currentOccasion = currentProduct.occasion || "";

      const items = snapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter((item) => item.isActive)
        .filter((item) => item.id !== currentProduct.id);

      const scored = items
        .map((item) => {
          let score = 0;

          if (item.occasion && item.occasion === currentOccasion) {
            score += 2;
          }

          const sharedCategories = item.category?.filter((cat) =>
            currentCategories.includes(cat)
          );

          if (sharedCategories?.length) {
            score += sharedCategories.length;
          }

          return { ...item, score };
        })
        .filter((item) => item.score > 0)
        .sort((a, b) => b.score - a.score)
        .slice(0, 8);

      setRelatedProducts(scored);
    };

    fetchRelatedProducts();
  }, [currentProduct]);

  if (!relatedProducts.length) return null;

  return (
    <section className="more-like-this">
      <div className="more-like-this-header">
        <p className="section-label">More Like This</p>
        <h2>Keep shopping similar cards</h2>
      </div>

      <div className="related-product-scroll">
        {relatedProducts.map((product) => (
          <Link
            to={`/product/${product.id}`}
            className="related-product-card"
            key={product.id}
          >
            <img
              src={product.imageUrl || `/cardImages/${product.id}.jpg`}
              alt={product.UITitle}
            />

            <div className="related-product-info">
              <h3>{product.UITitle}</h3>
              <p>${Number(product.price).toFixed(2)}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}